<div class="modern-admin-container">
  <!-- Modern Sub-Navigation Bar -->
  <nav class="admin-subnav">
    <div class="subnav-left">
      <ngx-workspace-switcher></ngx-workspace-switcher>
    </div>

    <div class="subnav-center tw-overflow-x-auto">
      <button class="chevron chevron-left" [class.visible]="canScrollLeft" (click)="onNavScroll(-1)" aria-label="Scroll left">
        <svg viewBox="0 0 24 24">
          <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
        </svg>
      </button>
      <div #navViewport class="nav-viewport" (scroll)="onNavViewportScroll()">
        <div class="nav-items" role="tablist" aria-label="Admin tools navigation">
          <!-- Statistics Dropdown -->
          <div class="nav-dropdown" [class.active]="activeView === 'statistics'">
            <app-dropdown
              [dropdownOptions]="statisticsOptions"
              [widthInPX]="'200px'"
              [minWidthInPX]="'200px'"
              [heightInPX]="242"
              [maxHeightInPX]="340"
              (optionClicked)="onStatisticSelected($event)"
            >
              <button class="nav-item dropdown-trigger" [class.active]="activeView === 'statistics'">
                <svg viewBox="0 0 24 24" class="nav-icon">
                  <path d="M22,21H2V3H4V19H6V17H10V19H12V16H16V19H18V17H22V21Z" />
                </svg>
                Statistics
                <svg viewBox="0 0 24 24" class="dropdown-arrow">
                  <path d="M7,10L12,15L17,10H7Z" />
                </svg>
              </button>
            </app-dropdown>
          </div>

          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'url-shortener'"
            [class.active]="activeView === 'url-shortener'"
            (click)="setActiveView('url-shortener')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path
                d="M3.9,12C3.9,10.29 5.29,8.9 7,8.9H11V7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H11V15.1H7C5.29,15.1 3.9,13.71 3.9,12M8,13H16V11H8V13M17,7H13V8.9H17C18.71,8.9 20.1,10.29 20.1,12C20.1,13.71 18.71,15.1 17,15.1H13V17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7Z"
              />
            </svg>
            URL Shortener
          </button>

          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'file-uploader'"
            [class.active]="activeView === 'file-uploader'"
            (click)="setActiveView('file-uploader')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            </svg>
            File Uploader
          </button>

          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'event-tools'"
            [class.active]="activeView === 'event-tools'"
            (click)="setActiveView('event-tools')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path
                d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9Z"
              />
            </svg>
            Event Tools
          </button>

          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'email-composer'"
            [class.active]="activeView === 'email-composer'"
            (click)="setActiveView('email-composer')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
            </svg>
            Email Composer
          </button>
          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'events-calendar'"
            [class.active]="activeView === 'events-calendar'"
            (click)="setActiveView('events-calendar')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z" />
            </svg>
            Events Calendar
          </button>

          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'migrate-event'"
            [class.active]="activeView === 'migrate-event'"
            (click)="setActiveView('migrate-event')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path
                d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V5H19V19M17,17H7V15H17V17M17,13H7V11H17V13M17,9H7V7H17V9M12,8L16,12L12,16M8,12H16"
              />
            </svg>
            Event Migration
          </button>
          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'feature-flags'"
            [class.active]="activeView === 'feature-flags'"
            (click)="setActiveView('feature-flags')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
            </svg>
            Feature Flags
          </button>
          <button
            class="nav-item"
            role="tab"
            [attr.aria-selected]="activeView === 'blacklist'"
            [class.active]="activeView === 'blacklist'"
            (click)="setActiveView('blacklist')"
          >
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path
                d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,13.85 4.63,15.55 5.68,16.91L16.91,5.68C15.55,4.63 13.85,4 12,4M12,20A8,8 0 0,0 20,12C20,10.15 19.37,8.45 18.32,7.09L7.09,18.32C8.45,19.37 10.15,20 12,20Z"
              />
            </svg>
            Blacklist
          </button>

          <button class="nav-item" type="button" (click)="goToTrustCenter()">
            <svg viewBox="0 0 24 24" class="nav-icon">
              <path d="M12,1L21,5V11C21,16.55 17.16,21.74 12,23C6.84,21.74 3,16.55 3,11V5L12,1M12,3.19L5,6.3V11C5,15.5 8,19.74 12,20.93C16,19.74 19,15.5 19,11V6.3L12,3.19M11,6H13V12H11V6M11,14H13V16H11V14Z" />
            </svg>
            Trust Center
          </button>
        </div>
      </div>
      <button class="chevron chevron-right" [class.visible]="canScrollRight" (click)="onNavScroll(1)" aria-label="Scroll right">
        <svg viewBox="0 0 24 24">
          <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
        </svg>
      </button>
    </div>
    <div class="subnav-right">
      <div class="nav-actions">
        <!-- Future: Add any global actions here -->
      </div>
    </div>
  </nav>
  <main class="admin-content">
    <!-- URL Shortener View -->
    <div *ngIf="activeView === 'url-shortener'" class="content-view url-shortener-view">
      <ngx-url-shortener></ngx-url-shortener>
    </div>

    <!-- Image Uploader View -->
    <div *ngIf="activeView === 'file-uploader'" class="content-view file-uploader-view">
      <app-file-uploader></app-file-uploader>
    </div>

    <!-- Event Tools Hub (Badge, Group Forms, Confirmation, Settings) -->
    <div *ngIf="activeView === 'event-tools'" class="content-view event-tools-view">
      <ngx-event-tools-hub></ngx-event-tools-hub>
    </div>

    <!-- Statistics View (already using separate component) -->
    <div *ngIf="activeView === 'statistics'" class="content-view statistics-view">
      <ngx-statistics [selectedTabIndex]="selectedStatisticTab"></ngx-statistics>
    </div>

    <!-- Email Composer View -->
    <div *ngIf="activeView === 'email-composer'" class="content-view email-composer-view">
      <ngx-email-composer></ngx-email-composer>
    </div>
    <!-- Events Calendar View -->
    <div *ngIf="activeView === 'events-calendar'" class="content-view events-calendar-view">
      <ngx-events-calendar></ngx-events-calendar>
    </div>
    <!-- Event Migration View -->
    <div *ngIf="activeView === 'migrate-event'" class="content-view migrate-event-view">
      <app-migrate-events></app-migrate-events>
    </div>
    <!-- Feature Flags View -->
    @if(activeView === 'feature-flags') {
    <div class="content-view feature-flags-view">
      <app-feature-flags></app-feature-flags>
    </div>
    }
    @if(activeView === 'blacklist') {
    <div class="content-view blacklist-view">
      <app-blacklist></app-blacklist>
    </div>
    }
  </main>
</div>
